
<template>
  <div class="container page  [ text-center ]">
    <h1 class="subtitle [ text-center ]"> </h1>

    <div v-if="type === 'enrollmentError'">
      <span class="text-danger d-block">{{message}}</span>

    </div>
    <div v-if="type === 'enrollmentSuccess' && enroll && !enroll.lista">
      <h1 class="subtitle [ text-center ]">
        Prenotazione {{enroll.Titolo}}
      </h1>
      <p>
        Conferma la tua prenotazione tramite il link presente nella email che riceverai all'indirizzo <strong><i>{{userEnroll.email}}</i></strong>
      </p>
      <h2>
        La tua adesione deve essere confermata entro 24 ore.
      </h2>
      <p>
        <strong>In caso contrario la tua prenotazione verrà annullata</strong> e i posti ritorneranno disponibili.
      </p>
      <p v-if="enroll.EmailContatto && enroll.EmailContatto!=''">
        In caso di problemi scrivi a <strong><a :href="'mailto:'+ enroll.EmailContatto">{{enroll.EmailContatto}}</a></strong>
      </p>
    </div>

    <div v-if="type === 'enrollmentSuccess' && enroll && enroll.lista">
      <h1 class="subtitle [ text-center ]">
        Prenotazione {{enroll.Titolo}}
      </h1>
      <p>
        La tua prenotazione è stata inserita <strong>IN LISTA D'ATTESA</strong>, sarai contattato nel caso si liberasse un posto.
      </p>
      <p v-if="enroll.EmailContatto && enroll.EmailContatto!=''">
        In caso di problemi scrivi a <strong><a :href="'mailto:'+ enroll.EmailContatto">{{enroll.EmailContatto}}</a></strong>
</p>
    </div>

    <div v-if="type === 'enrollmentConfirmation' && enroll">
      <h1 class="subtitle [ text-center ]">
        Conferma prenotazione
      </h1>
      La tua prenotazione all'evento <strong>{{enroll.SessioneEvento.Titolo}}</strong> del {{enroll.SessioneEvento.DataInizioEvento | formatEventDate}} &egrave; confermata.<br />
      <span v-if=" enroll.CodiciPrenotazione.length==1">
        Il tuo codice prenotazione &egrave;
      </span>
      <span v-if=" enroll.CodiciPrenotazione.length>1">
        I tuoi codici prenotazione sono
      </span>
      <strong class="d-block mb-2" v-for="codice in enroll.CodiciPrenotazione">{{codice}}</strong>

    </div>

    <div v-if="type === 'enrollmentConfirmationError'">
      <p v-if="message!= 'Numero massimo prenotazioni raggiunto'">
        {{message}}
      </p>
      <p v-if="message == 'Numero massimo prenotazioni raggiunto'">
        La tua richiesta non pu&ograve; essere accettata: hai raggiunto il numero massimo di prenotazioni per
        l'evento {{enroll.Titolo}} del {{enroll.DataInizioEvento | formatEventDate}}

      </p>
    </div>

    <span v-if="type === 'enrollmentCancellation'">
      <h1 class="subtitle [ text-center ]">
       Annullamento prenotazione
      </h1>
      La prenotazione <strong>{{enroll.CodicePrenotazione}}</strong>  &egrave; stata annullata come richiesto.<br />
      Riceverai a breve una email di conferma cancellazione

    </span>

    <span v-if="type === 'enrollmentCancellationError'">
      {{message}}
    </span>

    <span v-if="type === 'genericError'">
      GENERIC ERROR<br><br>
      {{message}}
    </span>

  </div>
</template>

<script>
export default {
  computed: {
    message () {
      return this.$store.state.message.message
    },
    type () {
      return this.$store.state.message.type
    },

    enroll () {
      return this.$store.state.message.enroll
    },
    userEnroll () {
      return this.$store.state.message.userEnroll
    }

  },
  created () {

  }
}
</script>
